import React, { useState } from "react";
import OoPopover from "../../../../components/UI/Popover/OoPopover";
import LatestSummaryCardData from "../../../DEIMaturityModel/Components/LatestSummaryCardData";
import MonthlyGuidesModal from "../../../DiversityCalendar/MonthlyGuidesModal";
import MonthlyGuidesTable from "../../../DiversityCalendar/MonthlyGuidesTable";
import ActionsPieChart from "../../../enterpriseAssociatedActions/ActionsPieChart";
import AvgCompletion from "../../../enterpriseAssociatedActions/AvgTaskCompletion";
import UniqueActionActivity from "../../../enterpriseAssociatedActions/UniqueActionActivity";
import Metrics from "../../../groups/Metrics/Metrics";
import "./module-analytics.css";

export default function ModulesAnalytics() {
  const [actionCount, setActionCount] = useState(0);
  return (
    <div className="modules-analytics-section">
      <div className="enterpriseStatsContainer row1">
        <div className="allStatsRow">
          <div className="enterprisePieChart col-md-3">
            <div className="ent_block_full">
              <span className="singleStatContainer">
                <span className="entObjHelpIcon">
                  <OoPopover
                    target="action_status_dash"
                    headerText="Action Status"
                    bodyText="Snapshot of progress on actions that are linked with an objective, indicated as: not started, in progress, or completed."
                  />
                </span>
                <div style={{ marginBottom: "8%" }}>
                  <span className="enterpriseObjTitle">Action Status</span>
                  <span className="enterpriseObjSubtitle">
                    across all objectives
                  </span>
                </div>

                <div
                // style={{width:"100%",height:"100%", minHeight:"300px"}}
                >
                  <ActionsPieChart
                    actionCount={actionCount}
                    eo_id={null}
                    isDashboardPage
                  />
                </div>
              </span>
            </div>
          </div>

          <div className="enterprisePieChart col-md-2">
            <div className="ent_block_half pb-2">
              <span className="singleStatContainer">
                <span className="entObjHelpIcon">
                  <OoPopover
                    target="activaley_engaged_dash"
                    headerText="Actively Engaged"
                    bodyText="Percentage of users with actions who have made at least one update on the platform to their action which may be private, public or linked with an objective."
                  />
                </span>
                <div>
                  <span className="enterpriseObjTitle">Actively Engaged</span>
                  <span className="enterpriseObjSubtitle">
                    users across all actions
                  </span>
                </div>
                <div className="text-center">
                  <UniqueActionActivity
                    actionCount={actionCount}
                    eo_id={null}
                  />
                </div>
              </span>
            </div>

            <div className="ent_block_half pt-2">
              <span className="singleStatContainer">
                <span className="entObjHelpIcon">
                  {" "}
                  <OoPopover
                    target="avg_completion_dash"
                    headerText="Average Completion"
                    bodyText="Average progress of all actions that are linked with objectives."
                  />{" "}
                </span>

                <div>
                  <span className="enterpriseObjTitle">Avg Completion</span>
                  <span className="enterpriseObjSubtitle">
                    of all objectives
                    {/* towards objectives */}
                  </span>
                </div>
                <div className="text-center">
                  <AvgCompletion actionCount={actionCount} eo_id={null} />
                </div>
              </span>
            </div>
          </div>

          <div className="enterprisePieChart col-md-2">
            <div className="ent_block_full mm_block_dashboard">
              <span className="singleStatContainer">
                <span className="entObjHelpIcon">
                  {" "}
                  <OoPopover
                    target="mm_score_dash"
                    headerText="Latest Workplace Assessment Score"
                    bodyText="Latest score for Workplace Assessment"
                  />
                </span>
                <div>
                  <span className="enterpriseObjTitle">
                    Latest Workplace Assessment Score
                  </span>
                </div>
                <div className="mt-5">
                  <LatestSummaryCardData />
                </div>
              </span>
            </div>
          </div>

          <div
            className="enterprisePieChart col-md-5 no-scr-mob"
            style={{
              maxHeight: "300px",
              overflowY: "hidden",
            }}
          >
            <MonthlyGuidesTable />
          </div>
        </div>

        <div className="" style={{ maxHeight: "350px", marginBottom: "2em" }}>
          <div className="enterprisePieChart col-md-12">
            <Metrics renderTableForAnalytics />
          </div>
        </div>
      </div>
    </div>
  );
}
